/** 字节 → 可读体积 */
export function formatBytes(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return "—";
  const n = Math.abs(value);
  if (n < 1024) return `${Math.round(n)} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toFixed(v >= 10 ? 0 : 1)} ${units[i]}`;
}

/** 速度（字节/秒） */
export function formatSpeed(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return "—";
  return `${formatBytes(value)}/s`;
}

/** 秒 → 可读时长 */
export function formatDuration(seconds?: number | null): string {
  if (seconds == null || seconds < 0 || Number.isNaN(seconds)) return "—";
  const s = Math.floor(seconds);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d} 天 ${h} 小时`;
  if (h > 0) return `${h} 小时 ${m} 分`;
  if (m > 0) return `${m} 分`;
  return `${s} 秒`;
}

/** 媒体主键：优先 tmdb / douban / bangumi */
export function mediaIdOf(media: {
  tmdb_id?: number | null;
  tmdbid?: number | null;
  douban_id?: string | null;
  doubanid?: string | null;
  bangumi_id?: number | null;
  bangumiid?: number | null;
}): string | null {
  const tmdb = media.tmdb_id ?? media.tmdbid;
  if (tmdb) return `tmdb:${tmdb}`;
  const douban = media.douban_id ?? media.doubanid;
  if (douban) return `douban:${douban}`;
  const bangumi = media.bangumi_id ?? media.bangumiid;
  if (bangumi) return `bangumi:${bangumi}`;
  return null;
}
